import { render } from "./ChemlabIcon.vue?vue&type=template&id=2c6c7d78&scoped=true"
import script from "./ChemlabIcon.vue?vue&type=script&lang=js"
export * from "./ChemlabIcon.vue?vue&type=script&lang=js"

import "./ChemlabIcon.vue?vue&type=style&index=0&id=2c6c7d78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6c7d78"]])

export default __exports__